import React, { FC } from "react"

const Eula: FC = () => {
    return (
        <div className="container py-8">
            <h1 className="text-2xl md:text-4xl font-bold">
                Super.AI Crowd Hero Agreement
            </h1>

            <p className="mb-4">
                This super.AI crowd hero agreement (the "crowd agreement") is a
                legal agreement between you ("you" or "crowd hero") and super.AI
                Inc. ("we" or "super.AI"). by clicking the "I accept" button,
                accepting or performing a task or otherwise using the platform,
                you acknowledge that you have reviewed and accept this Crowd
                Agreement. by accepting this Crowd Agreement or otherwise
                accessing or using the platform, you represent that you are at
                least 18 years old (or the age of majority in the jurisdiction
                in which you are located if such jurisdiction has an age of
                majority greater than 18) and have authority to bind yourself to
                this Crowd Agreement. if you do not agree with all of the terms
                of this Crowd Agreement, do not access or otherwise use the
                platform. Super.AI may make changes to the platform at any time.
                In addition, super.AI may make changes to this Crowd Agreement
                at any time. In the event it does so, super.AI will post notice
                of the changes on the log-in screen for the platform and require
                you to acknowledge and agree to the modified Crowd Agreement.
                Your continued use of the platform after such changes have been
                posted will signify your assent to and acceptance of the
                modified Crowd Agreement.
            </p>

            <p className="mb-4">
                <b>Note</b>: this Crowd Agreement contains a dispute resolution
                and arbitration provision, including a class action waiver, that
                affects your rights under this Crowd Agreement and with respect
                to disputes you may have with super.AI.
            </p>
            <div className="eula-list">
                <ol className="">
                    <li className="mb-4">
                        <b>DEFINITIONS</b>
                        <ol className="">
                            <li className="ml-3 my-2">
                                “<b>Authorized Purposes</b>” means performance
                                of the Tasks pursuant to the Instructions and
                                the terms set forth herein.
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Customer Content</b>” means that data
                                stored, posted, displayed, or otherwise
                                transmitted on the Platform by Customers to be
                                used in the performance of Tasks.
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Customers</b>” means those users of the
                                Platform who have provided Content, Tasks,
                                Instructions, and payment regarding the same.
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Customer Content</b>” means that data
                                stored, posted, displayed, or otherwise
                                transmitted on the Platform by Customers for the
                                purpose of performing the Tasks, but excluding
                                the Processed Content.
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Documentation</b>” means the printed, paper,
                                electronic or online user instructions and help
                                files made available by super.AI for use with
                                the Platform, as may be updated from time to
                                time by super.AI
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Instructions</b>” means the written
                                directions accompanying the Tasks directing you
                                as to how the Content should be tagged, labeled,
                                or otherwise processed, modified, or altered to
                                create the Processed Content. Instructions may
                                include sample versions of Customer Content in
                                which the Tasks have already been performed to
                                establish a gold standard of performance of the
                                Tasks.
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Intellectual Property Rights</b>” means all
                                intellectual property rights or similar
                                proprietary rights, including (a) patent rights
                                and utility models, (b) copyrights and database
                                rights, (c) trademarks, trade names, domain
                                names and trade dress and the goodwill
                                associated therewith, (d) trade secrets, (e)
                                mask works, and (f) industrial design rights; in
                                each case, including any registrations of,
                                applications to register, and renewals and
                                extensions of, any of the foregoing in any
                                jurisdiction in the world.
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Malicious Code</b>” means viruses, worms,
                                time bombs, Trojan horses and other harmful or
                                malicious code, files, scripts, agents or
                                programs
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Open Source Software</b>” means all software
                                that is available under the GNU Affero General
                                Public License (AGPL), GNU General Public
                                License (GPL), GNU Lesser General Public License
                                (LGPL), Mozilla Public License (MPL), Apache
                                License, BSD licenses, or any other license that
                                approved by the Open Source Initiative (
                                <a href="www.opensource.org">
                                    www.opensource.org
                                </a>
                                ).
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Platform</b>” means the super.AI service,
                                which allows you to perform Tasks pursuant to
                                the Instructions. For all purposes of this Crowd
                                Agreement, the definition of Platform excludes
                                any Open Source Software that may be used to
                                provide such services.
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Processed Content</b>” means the Content, as
                                modified by the Crowd Worker, in performing the
                                Tasks pursuant to the Instructions.
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Tasks</b>” means the service requested with
                                regard to the tagging, labeling, modification,
                                or alteration of the Content.
                            </li>
                            <li className="ml-3 my-2">
                                “<b>Worker System</b>” means the equipment and
                                services (other than the Platform) used by the
                                Crowd Hero in the performance of Tasks.
                            </li>
                        </ol>
                    </li>
                    <li className="mb-4">
                        <b>SUPER.AI’S ROLE AND LICENSES</b>
                        <ol className="eula-list">
                            <li className="ml-3 my-2">
                                <b>Super.AI’s Role</b>. The Platform is a venue
                                for Customers to provide Tasks to Crowd Hero.
                                Super.AI does not monitor or review the Tasks,
                                and accordingly, we have no control over the
                                quality, safety, or legality of Tasks. Your use
                                of the Platform is at your own risk.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Platform License</b>. Subject to your
                                compliance with the terms and conditions
                                contained in this Crowd Agreement, super.AI
                                hereby grants to you a limited, non-exclusive,
                                non-transferable right to access and use the
                                Platform in accordance with the Documentation
                                solely for your Authorized Purposes.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Customer Content License</b>. Subject to your
                                compliance with the terms and conditions
                                contained in this Crowd Agreement, super.AI
                                hereby grants to you a limited, non-exclusive,
                                non-transferable right to access and use the
                                Customer Content in accordance with the
                                Documentation solely for your Authorized
                                Purposes. The Customer Content is confidential
                                information, and you agree that (a) you shall
                                only use such Customer Content in the
                                performance of the tasks; and (b) such Customer
                                Content shall be subject to the confidentiality
                                provisions set forth in section 8 below.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Restrictions</b>. You shall not, directly or
                                indirectly, and you shall not permit any third
                                party to: (a) reverse engineer, decompile,
                                disassemble or otherwise attempt to discover the
                                object code, source code or underlying ideas or
                                algorithms of the Platform; (b) modify,
                                translate, or create derivative works based on
                                any element of the Platform or any related
                                Documentation; (c) rent, lease, distribute,
                                sell, resell, assign, or otherwise transfer its
                                rights to use the Platform; (d) use the Platform
                                for timesharing purposes or otherwise for the
                                benefit of any person or entity other than for
                                the benefit of you or the Customers; (e) remove
                                any proprietary notices from the Documentation;
                                (f) publish or disclose to third parties any
                                evaluation of the Platform without super.AI's
                                prior written consent; (g) use the Platform for
                                any purpose other than its intended purpose; (h)
                                interfere with or disrupt the integrity or
                                performance of the Platform; (i) introduce any
                                Open Source Software into the Platform; or (j)
                                attempt to gain unauthorized access to the
                                Platform or its related systems or networks.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Reservation of Rights</b>. Except as
                                expressly granted in this Crowd Agreement, there
                                are no other licenses granted to you, express,
                                implied or by way of estoppel. All rights not
                                granted in this Crowd Agreement are reserved by
                                super.AI.
                            </li>
                        </ol>
                    </li>
                    <li className="mb-4">
                        <b>
                            YOUR USE OF THE PLATFORM; ACCEPTABLE USE POLICY;
                            YOUR OBLIGATIONS
                        </b>
                        <ol className="eula-list">
                            <li className="ml-3 my-2">
                                <b>Registration, Passwords and Account Use</b>.
                                In registering to use the Platform, you will be
                                required to create an account (“<b>Account</b>”)
                                and must provide complete and accurate
                                information and ensure that information (as well
                                as any additional information we may require to,
                                among other things, verify your identity) is
                                complete, accurate, and up-to-date at all times.
                                You may not create multiple accounts. You are
                                solely responsible for maintaining the secrecy
                                and security of your password and Account, and
                                any use or action taken under your Account. If
                                your password is compromised, you must change
                                your password. You may not permit any other
                                person or entity to perform Tasks using your
                                Account. If you believe there is an error or
                                unauthorized transaction or activity associated
                                with your Account, contact us immediately.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Crowd Hero Conduct</b>. As a Crowd Hero, you
                                agree that: (i) you will interact with Customers
                                in a professional and courteous manner, and
                                provide reasonably requested information in
                                connection with your performance of Tasks; (ii)
                                you will perform the tasks in accordance with
                                the Instructions and with a sufficient level of
                                skill and care as is appropriate to the Task;
                                (iii) you will use your human intelligence and
                                independent judgment to perform Tasks in a
                                competent and workmanlike manner; (iv) you will
                                not use robots, scripts, or other automated
                                methods as a substitute for your human
                                intelligence or independent judgment to perform
                                Tasks; (v) you will supply complete and accurate
                                information for all Tasks you perform; (vi) you
                                will not perform Tasks through venues other than
                                the Platform; (vii) Customers may reject Tasks
                                you perform for good cause; and (viii) if you
                                are not a resident or citizen of the United
                                States, you will perform all Tasks outside of
                                the United States.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Work for Hire</b>. Any work product from
                                Tasks you perform (“<b>Work Product</b>”) is a
                                "work made for hire" for the benefit of the
                                Customer, and you (i) agree that all ownership
                                rights, including all intellectual property
                                rights, will vest with that Customer immediately
                                upon your performance of those Tasks, and (ii)
                                waive all moral or other proprietary rights that
                                you may have in that Work Product. To the extent
                                any ownership rights do not vest in the Customer
                                under applicable law, you hereby assign or
                                exclusively grant (without the right to any
                                compensation) all right, title, and interest,
                                including all Intellectual Property Rights, in
                                that work product to that Customer.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Work Product</b>. By providing Work Product,
                                you are promising us that: (i) you own all
                                rights in such Work Product or, alternatively,
                                you have acquired all necessary rights in your
                                Work Product to enable you to grant to us the
                                rights in your Work Product as described in this
                                Crowd Agreement; (ii) you have paid and will pay
                                in full all license fees, clearance fees, and
                                other financial obligations, of any kind,
                                arising from any use or commercial exploitation
                                of your Work Product; (iii) your Work Product
                                does not infringe the Intellectual Property
                                Rights, privacy rights, or any other legal or
                                moral rights of any third party; (iv) any
                                information contained in your Work Product is
                                not known by you to be false, inaccurate, or
                                misleading; (v) your Work Product does not
                                violate any law (including, but not limited to,
                                those governing export control, consumer
                                protection, unfair competition,
                                anti-discrimination, or false advertising); (vi)
                                your Work Product is not, and may not reasonably
                                be considered to be, defamatory, libelous,
                                hateful, racially, ethnically, religiously, or
                                otherwise biased or offensive, unlawfully
                                threatening, or unlawfully harassing to any
                                individual, partnership, or corporation, vulgar,
                                pornographic, obscene, or invasive of another's
                                privacy; (vii) your Work Product does not
                                incorporate materials from a third-party
                                website, or addresses, email addresses, contact
                                information, or phone numbers; and (viii) your
                                Work Product will not contain any Malicious
                                Code.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Independent Contractor</b>. You perform Tasks
                                in your personal capacity as an independent
                                contractor and not as an employee of a Customer
                                or super.AI. As a Crowd Hero, you agree that:
                                (i) you are responsible for and will comply with
                                all applicable laws and registration
                                requirements, including those applicable to
                                independent contractors and maximum working
                                hours regulations; (ii) this Crowd Agreement
                                does not create an association, joint venture,
                                partnership, franchise, or employer/employee
                                relationship between you and Customers, or you
                                and super.AI; (iii) you will not represent
                                yourself as an employee or agent of a Customer
                                or super.AI; (iv) you will not be entitled to
                                any of the benefits that a Customer or super.AI
                                may make available to its employees, such as
                                vacation pay, sick leave, and insurance
                                programs, including group health insurance or
                                retirement benefits; and (v) you are not
                                eligible to recover worker's compensation
                                benefits in the event of injury.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Acceptable Use Policy</b>. You acknowledge
                                and agree: (a) to abide by all local, state,
                                national, and international laws and regulations
                                applicable to your use of the Platform; (b) not
                                to send or store data on or to the Platform
                                which violates the rights of any individual or
                                entity established in any jurisdiction; (c) not
                                to upload in any way any information or content
                                that contain Malicious Code or data that may
                                damage the operation of the Platform or
                                another's computer or mobile device; (d) not to
                                use the Platform for illegal, fraudulent,
                                unethical or inappropriate purposes; (e) not to
                                interfere or disrupt networks connected to the
                                Platform or interfere with other ability to
                                access or use the Platform; (f) not to
                                distribute, promote or transmit through the
                                Platform any unlawful, harmful, obscene,
                                pornographic or otherwise objectionable material
                                of any kind or nature; (g) not to transmit or
                                post any material that encourages conduct that
                                could constitute a criminal offense or give rise
                                to civil liability; (h) not to access another’s
                                data or otherwise interfere with another
                                another’s use and enjoyment of the Platform or
                                another person or entity's use and enjoyment of
                                similar services; (i) not to use the Platform in
                                any manner that impairs the Platform, including
                                without limitation the servers and networks on
                                which the Platform is provided; (j) to comply
                                with all regulations, policies and procedures of
                                networks connected to the Platform and
                                super.AI’s service providers; and (k) to use the
                                Platform only in accordance with the
                                Documentation.
                            </li>
                            <li className="ml-3 my-2">
                                <b>
                                    Performance Tracking; Materials You Post or
                                    Provide
                                </b>
                                . We may implement mechanisms allowing us and
                                others to track your requests for, or your
                                performance of, Tasks, your use of the Platform
                                and rate your performance as a Crowd Hero, and
                                we reserve the right to collect such data
                                related to you, to use such data, including to
                                improve and compile statistical and performance
                                information related to the provision and
                                operation of the Platform, and to post such data
                                on the Platform. The Work Product that you
                                provide via the Platform may be retained and
                                used to improve the Platform and other machine
                                learning related products and services offered
                                by us. For any other information and materials
                                you post or otherwise provide to us related to
                                the Platform, including scripts, browser
                                plug-ins and extensions, or other programs for
                                use on the Platform (each, a "<b>Submission</b>
                                "), you grant us a non-exclusive, royalty-free,
                                perpetual, worldwide, irrevocable license to (i)
                                use, copy, distribute, transmit, make available,
                                publicly display, publicly perform, reproduce,
                                edit, adapt, modify, translate, reformat, create
                                derivative works of, and otherwise commercially
                                or non-commercially exploit in any manner, your
                                Submission in connection with operating and
                                improving the Platform, and (ii) sublicense
                                these rights. We will not pay you for your
                                Submission, and may remove your Submission at
                                any time. For each Submission you provide, you
                                represent that you have all rights necessary for
                                you to grant us the rights provided in this
                                section.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Privacy Policy</b>. By visiting or
                                registering for the Platform, you authorize the
                                collection, use, and disclosure of information
                                in accordance with the Privacy Policy.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Worker System</b>. You are responsible for
                                (a) obtaining, deploying and maintaining the
                                Worker System, and all computer hardware,
                                software, modems, routers and other
                                communications equipment necessary to access and
                                use the Platform via the Internet; (b)
                                contracting with third party ISP,
                                telecommunications and other service providers
                                to access and use the Platform via the Internet;
                                and (c) paying all third party fees and access
                                charges incurred in connection with the
                                foregoing.
                            </li>
                        </ol>
                    </li>
                    <li className="mb-4">
                        <b>PAYMENTS</b>
                        <ol className="eula-list">
                            <li className="ml-3 my-2">
                                <b>Payments</b>. For Tasks successfully
                                completed pursuant to the Instruction, for which
                                we receive payment from the Customers, we shall
                                forward such payment to your Account. You
                                authorize us, and third-party service providers
                                or agents acting on our behalf, to hold,
                                receive, and disburse funds in accordance with
                                your payment instructions. Your authorization
                                permits us to debit or credit your bank account
                                (including by generating a paper draft, a wire
                                (electronic or otherwise), ACH, or an electronic
                                funds transfer); (ii) transfer, disburse, or
                                process other payment transactions associated
                                with Tasks; (iii) settle payment for any fees
                                that may be charged under this Crowd Agreement;
                                and (iv) make, directly or through third
                                parties, inquiries to validate information that
                                you provide to us. If there is an error in the
                                processing of any transaction described above,
                                you authorize us to debit or credit your bank
                                account, as applicable, to correct the error. If
                                we are unable to debit your bank account for any
                                reason, you authorize us to resubmit the debit,
                                plus any applicable fees, to any other bank
                                account or payment instrument that you have on
                                file with us. Your authorizations will remain in
                                full force and effect while you maintain your
                                Account with us and for any bank account you
                                provide.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Taxes</b>. You agree that it is your
                                responsibility to determine any and all taxes
                                and duties, including without limitation, sales,
                                use, transfer, value added, and other taxes or
                                duties assessed, incurred or required to be
                                collected, or paid for any reason in connection
                                with any request for, or performance of Tasks,
                                or your use of the Platform, or otherwise in
                                connection with any action, inaction or omission
                                of you or any affiliate of yours, or any of your
                                or their respective employees, agents,
                                contractors or representatives ("Taxes") and to
                                collect, withhold, report, and remit correct
                                Taxes to the appropriate tax authority, and to
                                otherwise be responsible for the collection and
                                payment of any and all Taxes. We may withhold
                                and report on payments to workers to taxing
                                authorities. you agree that we are not obligated
                                to determine whether taxes apply and we are not
                                responsible to collect or remit any taxes
                                arising from any transaction.
                            </li>
                        </ol>
                    </li>
                    <li className="mb-4">
                        <b>Termination.</b> We may terminate this Crowd
                        Agreement, terminate or suspend your Account and access
                        to the Platform, or remove any Task listings immediately
                        without notice for any reason. Upon any termination or
                        suspension of this Crowd Agreement, your right to use
                        the Platform will cease, and you will not be able to
                        retrieve any information related to your account. If we
                        terminate this Crowd Agreement, then your Account
                        balance, less any amounts you owe us (including an
                        amount determined by us to be adequate to cover
                        chargebacks, refunds, adjustments, or other offsets we
                        are entitled to take in connection with your account),
                        may be withdrawn if all withdrawal-related
                        authentication requirements have been fulfilled.
                        However, if we terminate this Crowd Agreement for cause
                        (e.g., you have breached any of the terms or conditions
                        of this Crowd Agreement), your remaining account balance
                        (if any) may be forfeited. This sentence and the
                        following sections shall survive any termination of this
                        Crowd Agreement 2.1, 2.4, 2.5, 3.3-3.8, 4.2, 6-12.
                    </li>
                    <li className="mb-4">
                        <b>Disclaimer of warranties.</b> The Platform, the
                        Customer Content, the Documentation, the Instructions,
                        and the Tasks are provided on an "as is", "with all
                        faults" and "as available" basis. You expressly agree
                        that use of the Platform, Customer Content
                        Documentation, Instructions, and the Tasks are at your
                        sole risk. to the fullest extent permitted by applicable
                        law, we make no representations or warranties of any
                        kind, express or implied, as to the operation of the
                        Platform, the Customer Content, the Documentation,
                        Instructions or the Tasks, and disclaim any and all
                        representations or warranties of any kind, express or
                        implied, including without limitation: (a) any implied
                        warranties of merchantability, fitness for a particular
                        purpose, title, or non-infringement; (b) any warranty
                        that the Platform will meet your requirements, will
                        always be available, accessible, uninterrupted, timely,
                        secure, operate without error, or will contain any
                        particular features or functionality; (c) any warranty
                        that the information, content, materials, or submissions
                        included on the Platform will be as represented by
                        Customers, that the Tasks are lawful, or that Customers
                        will perform as promised or to your satisfaction; or (d)
                        any implied warranty arising from course of dealing or
                        usage of trade.
                    </li>
                    <li className="mb-4">
                        <b>Limitation of liability.</b> To the fullest extent
                        permitted by applicable law, we will not be liable for
                        any lost profits, indirect, incidental, punitive or
                        consequential damages (including any loss of revenue,
                        profits, goodwill, use, or data) arising in connection
                        with this Crowd Agreement, the Platform, the
                        Documentation, the Instructions, the Tasks, or
                        transactions through the Platform, even if we have been
                        advised of the possibility of those damages. further, to
                        the fullest extent permitted by applicable law, in no
                        event will our aggregate liability arising in connection
                        with this Crowd Agreement, the Platform, the Customer
                        Content, the Documentation, the Instructions, the Tasks,
                        or transactions through the Platform, exceed the total
                        amount of fees earned by super.AI in connection with
                        your performance of, Tasks during the three month period
                        immediately preceding the event giving rise to the claim
                        for liability. you acknowledge that the terms in this
                        section 7 (limitation of liability) shall apply to the
                        maximum extent permitted by applicable law and shall
                        apply even if an exclusive or limited remedy stated
                        herein fails of its essential purpose without regard to
                        whether such claim is based in contract, tort (including
                        negligence), product liability or otherwise.
                    </li>
                    <li className="mb-4">
                        <b>CONFIDENTIALITY</b>
                        <ol className="eula-list">
                            <li className="ml-3 my-2">
                                <b>Confidential Information. </b>"Confidential
                                Information” means any and all non-public
                                technical and non-technical information
                                disclosed by super.AI to you in any form or
                                medium, whether oral, written, graphical or
                                electronic, pursuant to this Crowd Agreement,
                                that is marked confidential and proprietary, or
                                that super.AI identifies as confidential and
                                proprietary, or that by the nature of the
                                circumstances surrounding the disclosure or
                                receipt ought to be treated as confidential and
                                proprietary information, including but not
                                limited to: (a) techniques, sketches, drawings,
                                models, inventions (whether or not patented or
                                patentable), know-how, processes, apparatus,
                                formulae, equipment, algorithms, software
                                programs, software source documents, and other
                                creative works (whether or not copyrighted or
                                copyrightable); (b) information concerning
                                research, experimental work, development, design
                                details and specifications, engineering,
                                financial information, procurement requirements,
                                purchasing, manufacturing, customer lists,
                                business forecasts, sales and merchandising and
                                marketing plans and information; (c) proprietary
                                or confidential information of any third party
                                who may disclose such information you or us in
                                the course of our business. Confidential
                                Information of super.AI shall include the
                                Platform, the Documentation, the Customer
                                Content and the Tasks.
                                <br />
                                <br />
                                <b>
                                    To be clear, the Customer Content is
                                    confidential information, regardless of
                                    whether so marked, and shall be subject to
                                    the terms of this section 8.
                                </b>
                                <br />
                                <br />
                                Confidential Information also includes all
                                summaries, screenshots, and abstracts of
                                Confidential Information.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Non-Disclosure</b>. You acknowledge that in
                                the course of the performance of this Crowd
                                Agreement, you may obtain Confidential
                                Information. You shall, at all times, both
                                during the Term and thereafter, keep in
                                confidence and trust all of the Confidential
                                Information that you’ve received. You shall not
                                use the Confidential Information other than as
                                necessary to fulfill your obligations under this
                                Crowd Agreement. You agree to secure and protect
                                super.AI’s Confidential Information with the
                                same degree of care and in a manner consistent
                                with the maintenance of your own Confidential
                                Information (but in no event less than
                                reasonable care). You shall not disclose
                                Confidential Information to any person or
                                entity.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Exceptions to Confidential Information</b>.
                                The obligations set forth in Section 8.2
                                (Non-Disclosure) shall not apply to the extent
                                that Confidential Information includes
                                information which: (a) was known by you prior to
                                receipt from the Disclosing Party either itself
                                or through receipt directly or indirectly from a
                                source other than one having an obligation of
                                confidentiality; (b) was developed by you
                                without use of the Confidential Information; or
                                (c) becomes publicly known or otherwise ceases
                                to be secret or confidential, except as a result
                                of a breach of this Crowd Agreement or any
                                obligation of confidentiality by you. Nothing in
                                this Crowd Agreement shall prevent you from
                                disclosing Confidential Information to the
                                extent you are legally compelled to do so by any
                                governmental investigative or judicial agency
                                pursuant to proceedings over which such agency
                                has jurisdiction; provided, however, that prior
                                to any such disclosure, you shall (x) assert the
                                confidential nature of the Confidential
                                Information to the agency; (y) immediately
                                notify us in writing of the agency’s order or
                                request to disclose; and (z) cooperate fully
                                with us in protecting against any such
                                disclosure and in obtaining a protective order
                                narrowing the scope of the compelled disclosure
                                and protecting its confidentiality.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Injunctive Relief</b>. You agree that any
                                unauthorized disclosure of Confidential
                                Information may cause immediate and irreparable
                                injury to super.AI and that, in the event of
                                such breach, we will be entitled, in addition to
                                any other available remedies, to seek immediate
                                injunctive and other equitable relief, without
                                bond and without the necessity of showing actual
                                monetary damages.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Destruction of Customer Content</b>. Upon the
                                completion of each Task and providing the Work
                                Product to super.AI and/or the Customer, you
                                agree to destroy (including deletion) all
                                Customer Content, Work Product, or any other
                                derivatives of the foregoing relating to such
                                Task and/or Work Product, including without
                                limitation any and all reports, studies,
                                analyses, screenshots, interpretations,
                                compilations, memoranda, notes and any other
                                written or electronic materials you’ve created
                                in the performance of the Task or otherwise
                                related to the Customer Content. Upon
                                termination of this Crowd Agreement, you agree
                                to destroy (including deletion) all copies of
                                the Confidential Information in your possession
                                or control. Upon request, you will provide the
                                super.AI a written certification of your
                                compliance with your obligations under this
                                Section.
                            </li>
                        </ol>
                    </li>
                    <li className="mb-4">
                        <b>INDEMNIFICATION</b>
                        <br />
                        <br />
                        You will indemnify, defend and hold harmless super.AI
                        and its affiliates (and their respective officers,
                        directors, employees, directors, agents and
                        representatives) from and against any and all claims,
                        costs, losses, damages, judgments, tax assessments,
                        penalties, interest and expenses (including reasonable
                        attorneys' fees) arising out of any claim, action,
                        audit, investigation, inquiry or other proceeding
                        instituted by a person or entity that arises out of or
                        relates to: (i) any actual or alleged breach of your
                        representations, warranties, or obligations set forth in
                        this Crowd Agreement; (ii) any Tasks you perform and any
                        Work Product or Submissions, including any actual or
                        alleged infringement or misappropriation of third-party
                        rights by any of that Work Product or Submissions; (iii)
                        your wrongful or improper use of the Platform; or (iv) a
                        dispute between you and any other Platform participant,
                        including without limitation, any Customer.
                    </li>
                    <li className="mb-4">
                        <b>PROPRIETARY RIGHTS</b>
                        <ol className="eula-list">
                            <li className="ml-3 my-2">
                                <b>Platform</b>. As between super.AI and you,
                                all right, title and interest in the Platform
                                and any other super.AI materials furnished or
                                made available hereunder (including without
                                limitation the Customer Content, the
                                Instructions, the Tasks, and the Documentation),
                                and all modifications and enhancements thereof,
                                and all suggestions, ideas and feedback proposed
                                by Customer regarding the Platform, including
                                all copyright rights, patent rights and other
                                Intellectual Property Rights in each of the
                                foregoing, belong to and are retained solely by
                                super.AI or super.AI’s licensors and providers,
                                as applicable. You may periodically provide
                                super.AI with written feedback regarding your
                                use of the Platform, the functionality of the
                                Platform, any bugs, errors or deficiencies that
                                Customer encounters regarding the operation and
                                functionality of the Platform and any
                                suggestions that Customer may have regarding
                                improvement of such operation and functionality
                                (“<b>Feedback</b>”). You hereby do and will
                                irrevocably assign to super.AI all Feedback and
                                all Intellectual Property Rights in the
                                Feedback.
                            </li>
                            <li className="ml-3 my-2">
                                <b>Further Assurances</b>. To the extent any of
                                the rights, title and interest in and to
                                Feedback or Intellectual Property Rights therein
                                cannot be assigned by you to super.AI, you
                                hereby grants to super.AI an exclusive,
                                royalty-free, transferable, irrevocable,
                                worldwide, fully paid-up license (with rights to
                                sublicense through multiple tiers of
                                sublicensees) to fully use, practice and exploit
                                those non-assignable rights, title and interest.
                                If the foregoing assignment and license are not
                                enforceable, you agree to waive and never assert
                                against super.AI those non-assignable and
                                non-licensable rights, title and interest.
                                Customer agrees to execute any documents or take
                                any actions as may reasonably be necessary, or
                                as super.AI may reasonably request, to perfect
                                ownership of the Feedback. If you are unable or
                                unwilling to execute any such document or take
                                any such action, super.AI may execute such
                                document and take such action on your behalf as
                                your agent and attorney-in-fact. The foregoing
                                appointment is deemed a power coupled with an
                                interest and is irrevocable.
                            </li>
                        </ol>
                    </li>
                    <li className="mb-4">
                        <b>
                            APPLICABLE LAW, DISPUTES
                            <br />
                            <br />
                            You agree that any dispute relating in any way to
                            this Crowd Agreement or the Tasks will be resolved
                            by binding arbitration, rather than in court
                        </b>
                        , except that you may assert claims in small claims
                        court if your claims qualify. The Federal Arbitration
                        Act and federal arbitration law and the laws of the
                        state of Washington, without regard to principles of
                        conflict of laws, will govern this Crowd Agreement and
                        any dispute of any sort that may arise between you and
                        super.AI.
                        <br />
                        <br />
                        <b>
                            There is no judge or jury in arbitration, and court
                            review of an arbitration award is limited. However,
                            an arbitrator can award on an individual basis the
                            same damages and relief as a court (including
                            injunctive and declaratory relief or statutory
                            damages), and must follow the terms of this Crowd
                            Agreement as a court would.
                        </b>
                        <br />
                        <br />
                        To begin an arbitration proceeding, you must send a
                        letter requesting arbitration and describing your claim
                        to <a href="mailto:legal@super.ai">legal@super.ai</a>.
                        The arbitration will be conducted by the American
                        Arbitration Association ("AAA") under its rules,
                        including the AAA's Supplementary Procedures for
                        Consumer-Related Disputes. The AAA's rules are available
                        at <a href="www.adr.org">www.adr.org</a> or by calling
                        1-800-778-7879. Payment of all filing, administration
                        and arbitrator fees will be governed by the AAA's rules.
                        We will reimburse those fees for claims totaling less
                        than $10,000 unless the arbitrator determines the claims
                        are frivolous. Likewise, we will not seek attorneys'
                        fees and costs in arbitration unless the arbitrator
                        determines the claims are frivolous. You may choose to
                        have the arbitration conducted by telephone, based on
                        written submissions, or in person in the county where
                        you live or at another mutually agreed location.
                        <br />
                        <br />
                        <b>
                            We each agree that any dispute resolution
                            proceedings will be conducted only on an individual
                            basis and not in a class, consolidated, or
                            representative action.
                        </b>
                        <br />
                        <br />
                        If for any reason a claim proceeds in court rather than
                        in arbitration, we each waive any right to a jury trial.
                        We also both agree that you or we may bring suit in
                        court to enjoin infringement or other misuse of
                        intellectual property rights. Notwithstanding anything
                        to the contrary in this Agreement, we may seek
                        injunctive or other relief in any state, federal, or
                        national court of competent jurisdiction for any actual
                        or alleged infringement of our or any other person or
                        entity's intellectual property or proprietary
                        rights.Foreign laws do not apply. Except for disputes
                        subject to arbitration as described above, any disputes
                        relating to this Crowd Agreement or the Platform will be
                        heard in the courts located in the state of Washington.
                    </li>
                    <li className="mb-4">
                        <b>MISCELLANEOUS</b>
                        <br />
                        <br /> You shall not assign your rights hereunder, or
                        delegate the performance of any of your duties or
                        obligations hereunder, whether by merger, acquisition,
                        sale of assets, operation of law, or otherwise, without
                        the prior written consent of super.AI. Any purported
                        assignment in violation of the preceding sentence is
                        null and void. Subject to the foregoing, this Crowd
                        Agreement shall be binding upon, and inure to the
                        benefit of, the successors and assigns of the parties
                        thereto. Except as otherwise specified in this Crowd
                        Agreement, this Crowd Agreement may be amended or
                        supplemented only by a writing that refers explicitly to
                        this Crowd Agreement and that is signed on behalf of
                        both parties. No waiver will be implied from conduct or
                        failure to enforce rights. No waiver will be effective
                        unless in a writing signed on behalf of the party
                        against whom the waiver is asserted. If any of the terms
                        of this Crowd Agreement is found invalid or
                        unenforceable that term will be enforced to the maximum
                        extent permitted by law and the remainder of the terms
                        will remain in full force. This Crowd Agreement
                        constitutes the entire agreement between the parties
                        relating to this subject matter and supersedes all prior
                        or simultaneous understandings, representations,
                        discussions, negotiations, and agreements, whether
                        written or oral. If you have any questions regarding
                        this Crowd Agreement or otherwise need to contact us,
                        you can reach us at{" "}
                        <a href="mailto:legal@super.ai">legal@super.ai</a>.
                    </li>
                </ol>
            </div>
        </div>
    )
}

export default Eula
